import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {IncomeCurrency} from '~local/app/types/IncomeCurrency';
import {Observable} from 'rxjs';

interface Total {
    count: number;
    difference: number;
    increase: boolean;
}

@Injectable()
export class DashboardService {
    constructor(private http: HttpClient) {}

    public getTotalCount(
        type: string,
        period: string = null,
        dateFrom: Date = null,
        dateTo: Date = null
    ): Observable<Total> {
        if (period != null) {
            return this.http.get<Total>(`/admin/dashboard/stats/${type}count/${period}`);
        }

        if (dateFrom != null && dateTo != null) {
            period = 'dateRange';
            return this.http.get<Total>(`/admin/dashboard/stats/${type}count/${period}/${dateFrom}/${dateTo}`);
        }

        return this.http.get<Total>(`/admin/dashboard/stats/${type}count`);
    }

    public getTransactionTotals(
        period: string = null,
        dateFrom: Date = null,
        dateTo: Date = null
    ): Observable<IncomeCurrency[]> {
        if (period != null) {
            return this.http.get<IncomeCurrency[]>(`/admin/dashboard/totals/${period}`);
        }

        if (dateFrom != null && dateTo != null) {
            period = 'dateRange';
            return this.http.get<IncomeCurrency[]>(`/admin/dashboard/totals/${period}/${dateFrom}/${dateTo}`);
        }

        return this.http.get<IncomeCurrency[]>(`/admin/dashboard/totals`);
    }

    public getActualBalance(): Observable<any> {
        return this.http.get<any>(`/admin/dashboard/balance`);
    }
}
